import React from 'react';
import PropTypes from 'prop-types';
import Select from '../inputs/Select';
import Button from '../buttons/Button';
import CheckboxInput from '../inputs/CheckboxInput';
import TextInput from '../inputs/TextInput';

class TableRow extends React.Component {
  constructor(props, context) {
    super(props, context);

    this.onEdit = this.onEdit.bind(this);
    this.onCellChange = this.onCellChange.bind(this);
    this.onCellSelectChange = this.onCellSelectChange.bind(this);
    this.onSave = this.onSave.bind(this);
    this.onCancel = this.onCancel.bind(this);
    this.onSelect = this.onSelect.bind(this);
    this.createActionCells = this.createActionCells.bind(this);
    this.convertValue = this.convertValue.bind(this);
    this.convertValueEditMode = this.convertValueEditMode.bind(this);
    this.addCopyIcon = this.addCopyIcon.bind(this);
    this.copyTextToClipboard = this.copyTextToClipboard.bind(this);

    this.state = {
      row: Object.assign({}, props.row),
      editMode: false,
    };
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    //Change this
    this.setState({
      row: nextProps.row,
    });
  }

  onEdit() {
    this.setState({
      editMode: true,
    });
  }

  onCellChange(event) {
    const row = this.state.row;
    row[event.target.name] = event.target.type === 'checkbox' ? event.target.checked : event.target.value;
    this.setState({ row });
  }

  onCellSelectChange(columnId, value) {
    const row = this.state.row;
    row[columnId] = value;
    this.setState({ row });
  }

  onSave() {
    if (this.props.onRowSave) {
      this.props.onRowSave(this.props.index, this.state.row);
    }
    this.onCancel();
  }

  onCancel() {
    this.setState({
      row: Object.assign({}, this.props.row),
      editMode: false,
    });
  }

  onSelect(event) {
    this.props.onSelect(event, this.props.index, event.target.checked);
  }

  createActionCells(actions) {
    return (
      <div className="rowActions">
        {actions.map((action, index) => {
          return (
            <Button
              key={index}
              extraClass={action.className ? action.className : 'rowAction bulk-action-btn secondary-btn'}
              buttonText={action.text}
              onClick={action.onClick}
              disabled={false}
            />
          );
        })}
      </div>
    );
  }

  copyTextToClipboard(e) {
    let text = e.target.id;
    let textArea = document.createElement('textarea');
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.select();

    try {
      let successful = document.execCommand('copy');
      document.body.removeChild(textArea);
      alert(successful ? 'Copied to clipboard!' : 'Something went wrong...');
    } catch (err) {
      document.body.removeChild(textArea);
    }
  }

  isValidDate(d) {
    return d instanceof Date && !isNaN(d);
  }

  convertValue(value, type, validValues, copyable) {
    const getSelectValueName = () => {
      let valueName = value;

      if (validValues) {
        validValues.some((option) => {
          if (option.id === value) {
            valueName = option.name;
            return true;
          }
          return false;
        });
      }

      return valueName;
    };

    const getDate = () => {
      let date = new Date(value);
      return (
        <div title={date.toString()}>
          {value && this.isValidDate(date) ? date.toJSON().slice(0, 10).replace(/-/g, '/') : '---'}
        </div>
      );
    };

    return (
      {
        bool: [true, 'true', 1, '1'].indexOf(value) >= 0 ? 'Yes' : 'No',
        date: getDate(),
        img: (
          <div
            className="bgImg"
            style={{ backgroundImage: 'url("' + value + '")', backgroundPosition: 'left', marginLeft: '10px' }}
          />
        ),
        select: getSelectValueName(),
      }[type] || (copyable ? this.addCopyIcon(value) : value)
    );
  }

  addCopyIcon(value) {
    return (
      <span>
        <i onClick={this.copyTextToClipboard} className="fa fa-files-o clickable" aria-hidden="true" id={value} />{' '}
        &nbsp;
        {value}
      </span>
    );
  }

  convertValueEditMode(value, type, name, info, validValues) {
    const renderer = (option) => <span>{option.name}</span>;
    const onSelectChange = (option) => {
      this.onCellSelectChange(name, option.id);
    };

    switch (type) {
      case 'select':
        return (
          <Select
            value={validValues.filter((v) => v.id === value)}
            getOptionLabel={(option) => option.name}
            getOptionValue={(option) => option.id}
            className="enum-dropdown"
            options={validValues}
            onChange={onSelectChange}
            clearable={false}
            searchable={false}
            valueRenderer={renderer}
            optionRenderer={renderer}
          />
        );
      case 'bool':
        return <CheckboxInput name={name} checked={value || false} onChange={this.onCellChange} />;
      default:
        return <TextInput name={name} value={value} onChange={this.onCellChange} infoText={info} />;
    }
  }

  render() {
    const cells = [];
    const editableColumns = this.props.editableColumns;
    let actionsCell;
    if (editableColumns && Object.keys(editableColumns).length) {
      if (this.props.cantEdit && this.props.cantEdit.length > 0 && this.props.cantEdit.includes(this.props.row.id)) {
        actionsCell = <div className="rowActions"></div>;
      } else if (!this.state.editMode) {
        actionsCell = this.createActionCells([
          {
            text: this.props.editText > '' ? this.props.editText : 'Edit',
            onClick: this.onEdit,
          },
        ]);
      } else {
        actionsCell = this.createActionCells([
          {
            text: 'Save',
            onClick: this.onSave,
          },
          {
            text: 'Cancel',
            onClick: this.onCancel,
            className: 'rowAction bulk-action-btn secondary-btn negative',
          },
        ]);
      }
    }

    this.props.columns.forEach((column, index) => {
      const info = editableColumns && editableColumns[column.id];
      const cents_to_dollars = column.cents_to_dollars || false;

      const value = cents_to_dollars ? this.state.row[column.id] / 100 : this.state.row[column.id];
      const type = column.type;
      const copyable = column.copy;

      if (info && this.state.editMode) {
        cells[index] = this.convertValueEditMode(value, type, column.id, info.description, info.validValues);
      } else {
        let cell = this.convertValue(value, type, info && info.validValues, copyable);

        if (cell === undefined || cell === null || cell === false) {
          cell = '---';
        }

        cells[index] = cell;
      }
    });

    let allCells = [];
    if (this.props.cantEdit && this.props.cantEdit.length > 0 && this.props.cantEdit.includes(this.props.row.id))
      allCells.push(
        <CheckboxInput
          key="0"
          name="select"
          checked={this.props.selected || false}
          onChange={this.onSelect}
          disabled={true}
          extraClass="select"
        />
      );
    else if (this.props.selectable !== false) {
      allCells.push(
        <CheckboxInput
          key="0"
          name="select"
          checked={this.props.selected || false}
          onChange={this.onSelect}
          extraClass="select"
        />
      );
    }
    allCells = [...allCells, ...cells, actionsCell].filter(function (n) {
      return n !== undefined;
    });
    return (
      <tr>
        {allCells.map((cell, index) => (
          <td
            className={typeof cell === 'object' && cell.props.className === 'rowActions' ? 'small-cell' : ''}
            key={index}
          >
            {typeof this.props.columnHeaders[index] !== 'object' &&
            this.props.columnHeaders[index] !== '' &&
            this.props.columnHeaders[index] !== undefined ? (
              <span className="hidden-sm hidden-md hidden-lg">
                <b> {this.props.columnHeaders[index]}: </b>
              </span>
            ) : (
              ''
            )}{' '}
            {cell}
          </td>
        ))}
      </tr>
    );
  }
}

TableRow.propTypes = {
  columns: PropTypes.array.isRequired,
  editableColumns: PropTypes.object,
  row: PropTypes.object.isRequired,
  index: PropTypes.number.isRequired,
  selectable: PropTypes.bool,
  selected: PropTypes.bool,
  onSelect: PropTypes.func,
  onRowSave: PropTypes.func,
  editText: PropTypes.string,
  columnHeaders: PropTypes.array.isRequired,
  cantEdit: PropTypes.array,
};

export default TableRow;
